<template>
  
    <v-card>
      <v-overlay
        :value="loading"
        :absolute="true"
        color="#fff"
        :opacity="1"
        
      >
        <v-progress-circular 
        indeterminate
        :value="60"
        color="blue-grey"
        >  
        </v-progress-circular>
      </v-overlay>
      <v-card-title primary-title v-if="page.id =='new'">
        New Page
      </v-card-title>
      <!--
      <v-card-title primary-title v-else>
        Page {{ page.name }}
      </v-card-title>
      -->
      <v-form
        ref="form"
        lazy-validation
      >
        <v-card-text>
          <v-container style="padding: 0px">
            <v-row>
              <v-col
                cols="12"
                md="4"
                class="pageForm"
              >
                <v-text-field
                  v-model="page.name"
                  label="Name"
                  :rules="nameRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="4"
                class="pageForm"
              >
                <v-switch v-model="page.isUpdateActive" label="Is Update Active"></v-switch>
              </v-col>
              <v-col
                cols="12"
                md="4"
                class="pageForm"
              >
                <v-switch v-model="page.tagVersion" label="Is New Tag"></v-switch>
              </v-col>
              
            </v-row>
            <v-row>

              <v-col
                cols="12"
                md="4"
                class="pageForm"
              >
                <v-text-field
                  v-model="page.adUnit"
                  label="Google Ad Unit"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="4"
               class="pageForm"
              >
                <v-text-field
                  v-model="page.targeting"
                  label="Targeting"
                ></v-text-field>
              </v-col>
            </v-row>
             <!-- BeOps Part -->
            <v-row>
             
            
              <v-col
                cols="12"
                md="3"
                class="pageForm"
              >
                <v-switch v-model="page.isBeOpsActive" label="Is BeOps Active"></v-switch>
              </v-col>
              <v-col
                cols="12"
                md="3"
                class="pageForm"
                v-if="page.isBeOpsActive"
              >
                <v-text-field
                  v-model="page.beOpsId"
                  label="beOpsId"
                ></v-text-field>
              </v-col>
              <v-col
                v-if="page.isBeOpsActive"
                cols="12"
                md="3"
                class="pageForm"
              >
                <v-text-field
                  v-model="page.beOpsSelector"
                  label="beOpsSelector"
                ></v-text-field>
              </v-col>
              <v-col
                v-if="page.isBeOpsActive"
                cols="12"
                md="3"
                class="pageForm"
              >
                <v-text-field
                  v-model="page.beOpsPosition"
                  label="beOpsPosition"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Adjesty Part -->
            <v-row>
              <v-col
                
                cols="12"
                md="4"
                class="pageForm"
              >
                 <v-switch v-model="page.isAdjestyActive" label="Is Adjesty Active"></v-switch>
              </v-col>
            </v-row>
            <!-- Lazyloading Part -->
            <v-row>
              <v-col
                
                cols="12"
                md="4"
                class="pageForm"
              >
                 <v-switch v-model="page.isLazyLoadingActive" label="Is Lazy Loading Active"></v-switch>
              </v-col>
            </v-row>
            
          </v-container>
        
        </v-card-text>
        <v-card-actions class="d-flex flex-row-reverse">
          <v-btn 
            @click="submit"
            rounded color="success" 
            style="margin: 10px"
            :loading="submitLoading"
            :disabled="submitLoading"
          >
            Valider
          </v-btn>
          <v-btn rounded color="danger" @click="back" style="margin: 10px">Retour</v-btn>
        </v-card-actions>
               
      </v-form>
    </v-card>

  
</template>

<script>
  import axios from 'axios'
  export default {
    props: ['page'],
    data() {
      return {
        loading : false,
        nameRules: [v => !!v || 'Name is required'],
        submitLoading : false,

        //items: ['Desktop', 'Tablet', 'Mobile', 'Video'],
        tab: null
      }
    },
    watch:{
    },
    created(){
      //console.log(this.page)
    },
    methods: {
      async submit(){
        this.submitLoading = true
        if (!this.$refs.form.validate()) {
          console.log('No fullfilled')
          return;
        }
        if(this.page.isUpdateActive  == false) this.page.isUpdateActive = 0
        if(this.page.isBeOpsActive  == false) this.page.isBeOpsActive = 0
        if(this.page.isAdjestyActive  == false) this.page.isAdjestyActive = 0 
        if(this.page.isLazyLoadingActive  == false) this.page.isLazyLoadingActive = 0 
         const request = {
            type : "management/page",
            action : "updateDetails",
            data : this.page
         }
         try{
           const accessToken = await this.$auth.getAccessToken()
          const response = await axios.post('/', JSON.stringify(request),{ headers: {Authorization: `Bearer ${accessToken}`}})
          if(response.data){
            this.submitLoading = false
            this.$emit('pageUpdated')
            //this.back()
          }
         } catch (e) {
          console.error(e)
          this.loading = false
          this.submitLoading = false 
        }

      },
      back(){
        this.$router.push('/management/'+this.page.siteId + '/pages');
      },
      
    }
  }
</script>

<style>
  .pageForm {
    padding-left: 50px; padding-right: 50px; padding-top: 0px; padding-bottom: 0px;
  }
</style>